// ** Icons Import
import { User } from "react-feather";

export default [
  {
    id: "kullanicilar",
    title: "Merchants",
    icon: <User size={20} />,
    badge: "light-warning",
    navLink: "/merchants",
  },
];
